const getAdminDomain = (environment) => {
    switch (environment) {
        case 'production':
            return 'https://app.microcasting.org';
        case 'main':
            return 'https://main.microcasting.com';
        case 'demo':
            return 'https://demo.microcasting.com';
        default:
            return 'http://localhost:3000';
    }
};
const baseUrl = (store, organization, portal) => {
    // console.log('ITEM is', item);
    if (!portal || !organization) {
        throw new Error('Portal and organization are required');
    }
    if (portal.publicDomain) {
        return `https://${portal.publicDomain}`;
    }
    return `${getAdminDomain(store.amplifyEnvironment)}/portal/${organization.id}/${portal.id}`;
};
export default baseUrl;
//# sourceMappingURL=baseUrl.js.map